import React, { useState, useEffect } from 'react';
import './styles.css';
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Input,
} from 'antd';
import Logo from '@BUP/assets/Images/bup_logo.png';
import { useAuth } from '@BUP/hooks';
import { useParams, useHistory } from 'react-router-dom';
import { BraveBupAPI } from '@BUP/services/Axios';


const SignUpPage = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);
  const { code: invitationCode } = useParams();
  const { signUp } = useAuth();

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const { email, password, name } = values;
      await signUp(email, password, name, invitationCode);
      setError(null);
      history.push('/');
      //form.resetFields();
    } catch (e) {
      console.log("onSubmit error", e);
      setError(e)
    }
  };

  useEffect(() => {
    const validateCode = async () => {
      try {
        const response = await BraveBupAPI.get(`/invitations/validate/${invitationCode}`);
        const email = response?.data?.email;
        form.setFieldsValue({
          email: email,
        });
      } catch (e) {
        const error = e.response.data;
        setError(error);
      }
    }
    validateCode();
  }, [invitationCode])

  return (
    <div className="signup-page-container">
      <div className="logo-wrapper">
        <img
          id="bup-logo"
          alt="BraveUp-Logo"
          src={Logo}
          style={{
            width: 300,
            height: 45,
          }}
        />
      </div>
      <div className="card-container">
        <Card
          className="signup-card"
          bodyStyle={{ padding: 0 }}
        >
          <Row>
            <Col xs={24} className="card-header-wrapper">
              REGISTRA TU CUENTA
            </Col>
            {
              error && error.message ? (
                <Col xs={24} className="card-error-wrapper">
                  <span>{error?.message}</span>
                </Col>
              ) : null
            }
            <Col xs={24} className="card-form-wrapper">
              <Form layout="vertical" form={form} onFinish={onSubmit}>
                <Form.Item
                  label="Correo Electrónico"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Campo requerido.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    disabled={true}
                    placeholder="ej: micorreo@braveup.com"
                    disabled={true}
                  />
                </Form.Item>
                <Form.Item
                  label="Nombre"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Campo requerido.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="ej: Nombre Apellido"
                  />
                </Form.Item>
                <Form.Item
                  label="Contraseña"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Campo requerido.",
                    },
                  ]}
                >
                  <Input.Password size="large" placeholder="*********" />
                </Form.Item>
                <Form.Item shouldUpdate={true}>
                  {() => (
                    <Button
                      type="primary"
                      block={true}
                      style={{ borderRadius: '0px' }}
                      size="large"
                      htmlType="submit"
                      disabled={
                        !form.isFieldsTouched(true) ||
                        form
                          .getFieldsError()
                          .filter(({ errors }) => errors.length).length
                      }
                    >
                      Registrar
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  )
}

export default SignUpPage;